/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 基本契約
 */
export interface Sgkb575aResBasiccontract {
    /** 
     * 基本契約対象年次：半角数字
     */
    basiccontractTargetyear?: string;
    /** 
     * 開始日付：日付YYYYMMDD
     */
    startDate?: string;
    /** 
     * 終了日付：日付YYYYMMDD
     */
    endDate?: string;
    /** 
     * 契約年間最高使用量：半角数値(小数点なし)
     */
    ctrAnnualmaximumEmpamt?: number;
    /** 
     * 契約年間最低使用量：半角数値(小数点なし)
     */
    ctrAnnualminimumEmpamt?: number;
}
